<template>
  <div>
    <v-navigation-drawer v-model="sideNav" fixed temporary color="#ffffff">
      <v-layout pt-4 wrap justify-center>
        <v-flex
          xs12
          v-for="(item, i) in navItems"
          :key="i"
          text-center
          pa-2
          pl-4
          text-uppercase
          align-self-center
        >
          <router-link :to="item.route">
            <v-layout wrap justify-center>
              <v-flex xs12>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 15px;
                    color: #e7ab5f;
                    letter-spacing: 2px;
                  "
                  >{{ item.name }}</span
                >
              </v-flex>
              <v-flex xs12 pt-2>
                <v-divider color="#fff"></v-divider>
              </v-flex>
            </v-layout>
          </router-link>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>

    <v-app-bar
      app
      elevate-on-scroll
      class="hidden-md-and-down"
      :color="transAppBar ? 'transparent' : 'white'"
      v-scroll="onScroll"
    >
      <!-- src="./../../assets/logo.png" -->
      <!-- src="../../assets/images/asset 36.png" -->
      <v-layout wrap>
        <v-flex pl-4 text-right lg4>
          <router-link to="/">
            <v-img :src="baseURL+homePage.logo" contain  height="55px"></v-img>
          </router-link>
        </v-flex>

        <v-flex
          v-for="(item, i) in navItems"
          :key="i"
          align-self-center
          text-uppercase
        >
          <router-link :to="item.route">
            <v-btn
              v-if="
                $route.path == '/*' ||
                $route.path == '/contactUs' ||
                $route.path == '/projects'
              "
              text
              :color="transAppBar ? '#545454' : '#545454'"
              class="menu-btn"
            >
              <span
                :class="$route.path == item.route ? 'menu-btn1' : 'menu-btn'"
              >
                {{ item.name }}
              </span>
            </v-btn>
            <v-btn v-else text :color="transAppBar ? 'white' : '#545454'">
              <span
                :class="$route.path == item.route ? 'menu-btn1' : 'menu-btn'"
              >
                {{ item.name }}
              </span>
            </v-btn>
          </router-link>
        </v-flex>
      </v-layout>
    </v-app-bar>

    <v-app-bar
      app
      elevate-on-scroll
      v-scroll="onScroll"
      :color="transAppBar ? 'transparent' : 'white'"
      class="hidden-lg-and-up"
    >
      <v-app-bar-nav-icon @click.native="sideNav = !sideNav">
        <v-icon
          v-if="$route.path == '/'"
          style="cursor: pointer"
          :color="transAppBar ? '#ffffff' : '#e7ab5f'"
          >mdi-menu</v-icon
        >
        <v-icon
          v-else
          style="cursor: pointer"
          :color="transAppBar ? '#e7ab5f' : '#e7ab5f'"
          >mdi-menu</v-icon
        >
      </v-app-bar-nav-icon>
       <v-spacer></v-spacer>
      <v-toolbar-title>
        <router-link to="/">
          <v-img
        :src="baseURL+homePage.logo"
            height="10 0px"
            width="140px"
            contain
          ></v-img> </router-link
      ></v-toolbar-title>
    </v-app-bar>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      transAppBar: true,
      whiteAppBar: false,
      scrollY: 0,
      sideNav: false,
      homePage:[],
      navItems: [
        { name: "Home", route: "/", type: "link" },
        { name: "About Us", route: "/aboutUs", type: "link" },
        { name: "Services", route: "/services", type: "link" },
        { name: "Clients", route: "/projects", type: "link" },
        { name: "Contact Us", route: "/contactUs", type: "link" },
      ],
    };
  },
  mounted:function(){
    this.getHome();
  },
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;

      if (top > 2) {
        this.transAppBar = false;

        // console.log("scrolled", top)
      } else {
        this.transAppBar = true;
      }
    },
      getHome() {
      axios({
        method: "GET",
        url: "/homepage/view",
      })
        .then((response) => {
          if(response.data.status)
          this.homePage = response.data.data;
        })
        .catch(() => {});
    },
    
  },
};
</script>

<style >
.menu-btn {
  font-family: poppinsbold;
  font-size: 14px;
  cursor: pointer;
}
.menu-btn::before {
  background-color: transparent !important;
  color: transparent !important;
}

.menu-btn1:hover {
  color: #e7ab5f;
  /* font-size: 15px; */
}
.menu-btn1 {
  font-size: 14px;
  cursor: pointer;
  color: #e7ab5f;
  font-family: poppinsbold;
}
.menu-btn1::before {
  background-color: transparent !important;
  color: #e7ab5f !important;
}

.menu-btn1:hover {
  color: #e7ab5f;
  /* font-size: 15px; */
}
.menu-btn:active {
  color: #e7ab5f;
  cursor: pointer;
}
.router-link-exact-active {
  opacity: 1;
  color: #e7ab5f;
}
</style>